// extracted by mini-css-extract-plugin
export default {"wishlistSearchEntry":"JiyMwrGi6wHGBNuILYZ+Pg=="};